import React from 'react';
import Modal from "react-bootstrap/Modal";
import { EXPLORER_URL, URL } from '../../../utils/constant';
import { formatAddress } from '../../../helper';
const SuccessModal = ({ show, onHide, formData, trxHash, cropAddress, childPoolId, onViewPool, rewardToken }) => {

  // Construct share link
  const shareLink = `${window.location.origin}/stakingpool?id=${childPoolId}`;

  // Copy link handler
  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    alert("Pool link copied to clipboard!");
  };

  // View pool handler (open in new tab)
  const handleViewPool = () => {
    window.open(shareLink, "_blank");
  };

  return (
    <Modal className="success" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Success</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="innercontentmodal">
          <div className="upperheading">
            <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
              <path d="M41.4699 23.5385L27.1149 37.8935C26.6621 38.3436 26.0496 38.5962 25.4112 38.5962C24.7727 38.5962 24.1602 38.3436 23.7074 37.8935L16.4574 30.6435C16.0024 30.1916 15.7454 29.5775 15.7432 28.9362C15.7409 28.2949 15.9935 27.6789 16.4454 27.2239C16.8972 26.7688 17.5113 26.5119 18.1526 26.5096C18.7939 26.5073 19.4099 26.7599 19.8649 27.2118L25.3508 32.6976L37.9899 20.0343C38.4427 19.5842 39.0552 19.3315 39.6937 19.3315C40.3321 19.3315 40.9446 19.5842 41.3974 20.0343C41.6398 20.2551 41.8347 20.5229 41.9703 20.8215C42.1059 21.12 42.1793 21.443 42.1861 21.7708C42.1929 22.0986 42.1329 22.4244 42.0098 22.7283C41.8866 23.0322 41.703 23.3078 41.4699 23.5385Z" fill="#00603B" />
              <path d="M29.0003 2.4165C21.95 2.4165 15.1884 5.21724 10.2031 10.2026C5.21773 15.1879 2.41699 21.9495 2.41699 28.9998C2.41699 36.0502 5.21773 42.8118 10.2031 47.7971C15.1884 52.7825 21.95 55.5832 29.0003 55.5832C36.0507 55.5832 42.8123 52.7825 47.7976 47.7971C52.7829 42.8118 55.5837 36.0502 55.5837 28.9998C55.5837 21.9495 52.7829 15.1879 47.7976 10.2026C42.8123 5.21724 36.0507 2.4165 29.0003 2.4165ZM41.4703 23.5382L27.1153 37.8932C26.6625 38.3433 26.05 38.5959 25.4116 38.5959C24.7731 38.5959 24.1606 38.3433 23.7078 37.8932L16.4578 30.6432C16.2215 30.422 16.0319 30.1556 15.9004 29.8598C15.7689 29.5641 15.6981 29.2449 15.6921 28.9213C15.6862 28.5976 15.7453 28.2761 15.8659 27.9757C15.9865 27.6753 16.1662 27.4021 16.3942 27.1725C16.6223 26.9428 16.8942 26.7612 17.1937 26.6385C17.4932 26.5157 17.8144 26.4544 18.138 26.458C18.4617 26.4617 18.7814 26.5302 19.0781 26.6597C19.3748 26.7891 19.6425 26.9767 19.8653 27.2115L25.3512 32.6973L37.9903 20.034C38.4431 19.5839 39.0556 19.3313 39.6941 19.3313C40.3325 19.3313 40.945 19.5839 41.3978 20.034C41.6402 20.2548 41.8351 20.5226 41.9707 20.8212C42.1063 21.1197 42.1797 21.4427 42.1865 21.7705C42.1933 22.0983 42.1333 22.4241 42.0102 22.728C41.8871 23.0319 41.7034 23.3075 41.4703 23.5382Z" fill="url(#paint0_linear_88_1158)" />
              <defs>
                <linearGradient id="paint0_linear_88_1158" x1="29.0003" y1="2.4165" x2="29.0003" y2="55.5832" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#9CFFAC" />
                  <stop offset="1" stop-color="#00B59C" />
                </linearGradient>
              </defs>
            </svg>
            <h2>Your Child Pool is Live!</h2>
            <p>
              You’ve staked <span>{formData.stakingAmount + " " + rewardToken?.symbol || '—'}</span> and launched a new Child Pool under the {" " + formData.selectedToken?.projectName} Root Pool.
            </p>
          </div>

          {/* Token Info */}
          <div className="tokenbox">
            <div className="parenttoken">
              <div className="left">
                <h2>Reward Token</h2>
              </div>
              <div className="right">
                <p>{cropAddress(formData.selectedToken?.rewardToken)}</p>
                <button>
                  {rewardToken?.symbol || '—'}
                </button>
              </div>
            </div>

            <div className="parenttoken">
              <div className="left"><h2>Fee Set</h2></div>
              <div className="right"><p>{formData?.creatorFee}%</p></div>
            </div>

            {/* <div className="parenttoken">
              <div className="left"><h2>Staked Amount</h2></div>
              <div className="right">
                <p>{formData.stakingAmount || '—'}</p>
                <img
                  src={formData.selectedToken?.logo || "\\assets\\img.png"}
                  alt="img"
                  className="img-fluid stakedclas"
                />
              </div>
            </div>

            <div className="parenttoken">
              <div className="left"><h2>Pool</h2></div>
              <div className="right"><p>{cropAddress(formData.selectedToken?.unifarm)}</p></div>
            </div> */}

            <div className="parenttoken">
              <div className="left"><h2>Transaction Hash</h2></div>
              <div className="right">
                <p>{trxHash ? cropAddress(trxHash) : '—'}</p>
                {trxHash && (
                  <svg
                    onClick={() => window.open(`${EXPLORER_URL}${trxHash}`, '_blank')}
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    style={{ cursor: "pointer" }}
                  >
                    <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#707F9B" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10.5 1.5L6 6" stroke="#707F9B" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.5 1.5H10.5V4.5" stroke="#707F9B" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </div>
            </div>

            <div className="parenttoken forbacknew lasstest">
              <div className="left"><h2>Status:</h2></div>
              <div className="right"><p className='pooolside'>Pool is now visible to stakers.</p></div>
            </div>
          </div>

          {/* Share Pool Link */}
          <div className="sharepoolbox">
            <div className="leftshare">
              <p>Share Pool Link</p>
              <h6>{formatAddress(shareLink)}</h6>
            </div>
            <div className="rightshare">
              <button onClick={handleCopy}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M11.667 4.6665H5.8337C5.18933 4.6665 4.66699 5.18884 4.66699 5.83317V11.6665C4.66699 12.3108 5.18933 12.8332 5.83366 12.8332H11.667C12.3113 12.8332 12.8337 12.3108 12.8337 11.6665V5.83317C12.8337 5.18884 12.3113 4.6665 11.667 4.6665Z" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2.33366 9.33317C1.69199 9.33317 1.16699 8.80817 1.16699 8.16651V2.33317C1.16699 1.6915 1.69199 1.1665 2.33366 1.1665H8.16699C8.80866 1.1665 9.33366 1.6915 9.33366 2.33317" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Copy
              </button>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="lastbutton">
          <button className="close" onClick={onHide}>Close</button>
          <button className="view" onClick={handleViewPool}>View Pool Page</button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
